import { render, staticRenderFns } from "./CandidateInterviewListingBody.vue?vue&type=template&id=4d38b591&scoped=true&"
import script from "./CandidateInterviewListingBody.vue?vue&type=script&lang=ts&"
export * from "./CandidateInterviewListingBody.vue?vue&type=script&lang=ts&"
import style0 from "./CandidateInterviewListingBody.vue?vue&type=style&index=0&id=4d38b591&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d38b591",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VChip,VCol,VIcon,VPagination,VRow,VSkeletonLoader})
